import { Action, createReducer, on } from '@ngrx/store';
import * as fromGetRiskCategoriesActions from '../actions';

export const getRiskFactorFeatureKey = 'getRiskFactor';

export interface State {
  loaded: boolean;
  error?: Error | any;
  getRiskCategories: any;
}

export const initialState: State = {
  loaded: false,
  error: undefined,
  getRiskCategories: undefined
};

export const reducer = createReducer(
  initialState,
  on(
    fromGetRiskCategoriesActions.loadGetRiskFactors,

    state => state
  ),
  on(fromGetRiskCategoriesActions.loadGetRiskFactorsSuccess, (state, action) => ({
    ...state,
    getRiskCategories: action.response,
    loaded: true
  })),

  on(fromGetRiskCategoriesActions.loadGetRiskFactorsFailure, (state, { error }) => ({
    ...state,
    error
  }))
);

export const selectRiskCategories = (state: State) => state.getRiskCategories;
export const selectRiskCategoriesLoaded = (state: State) => state.loaded;
export const selectRiskCategoriesError = (state: State) => state.error;
